import axiosInstance from '../config/axios';

/**
 * Create a new refund request (Student)
 * @param {Object} payload - { transaction_id, amount, reason }
 */
export const createRefundRequestApi = (payload) =>
  axiosInstance.post('/refund-requests', payload).then((res) => res.data);

/**
 * Get user's submitted refund requests list (Student)
 */
export const getMyRefundRequestsApi = () =>
  axiosInstance.get('/refund-requests').then((res) => res.data);

/**
 * Get refund request by ID (Student)
 * @param {string} id
 */
export const getRefundRequestByIdApi = (id) =>
  axiosInstance.get(`/refund-requests/${id}`).then((res) => res.data);

/**
 * List incoming refund requests for teacher's items (Teacher)
 * @param {string} [status='pending']
 */
export const getTeacherRefundRequestsApi = (status = 'pending') =>
  axiosInstance.get('/teacher-refund-requests', { params: { status } }).then((res) => res.data);

/**
 * Approve a refund request (Teacher)
 * @param {string} id
 */
export const approveRefundRequestApi = (id) =>
  axiosInstance.post(`/teacher-refund-requests/${id}/approve`).then((res) => res.data);

/**
 * Reject a refund request (Teacher)
 * @param {string} id
 * @param {string} [notes]
 */
export const rejectRefundRequestApi = (id, notes = '') =>
  axiosInstance.post(`/teacher-refund-requests/${id}/reject`, { notes }).then((res) => res.data);

/**
 * Get completed refunds history (Teacher)
 */
export const getTeacherRefundsDoneApi = () =>
  axiosInstance.get('/teacher-refunds-done').then((res) => res.data);
